import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  IFetchAccountUsersPayload,
  ICreateAccountUsersPayload,
  IDeleteAccountUsersPayload,
  IChangeRolePayload,
} from './types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function fetchAccountUsers(payload: IFetchAccountUsersPayload) {
  return axios.get('/api/v1/account_users', { params: convertToSnakeCase(payload) })
}

export function createAccountUsers(payload: ICreateAccountUsersPayload) {
  return axios.post(`/api/v1/accounts/${payload.accountId}/create_account_users`, convertToSnakeCase(payload), config)
}

export function deleteAccountUsers(payload: IDeleteAccountUsersPayload) {
  return axios.delete(`/api/v1/account_users/`,  { ...config, data: convertToSnakeCase(payload) })
}

export function changeRole(payload: IChangeRolePayload) {
  return axios.put(`/api/v1/account_users/${payload.accountUserId}/change_role`, convertToSnakeCase(payload), config)
}
